/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */

type LogoProps = {
    className?: string;
    color?: string;
};

const Logo = ({ className, color }: LogoProps) => {
    const defaultColor = '#000';
    return (
        <div className={`${className}`}>
            <svg viewBox="0 0 616 616">
                <g fill="none" fillRule="evenodd">
                    <g fill={color ?? defaultColor} fillRule="nonzero">
                        <path d="M412 448a66 66 0 1 1 0 132 66 66 0 0 1 0-132ZM204.4 36A66.5 66.5 0 0 1 256 144.5l-7.7 9.5-1 1.2c-12.3 15.3-24 31.8-24 51v7.1c0 16 9.7 29.9 20.8 42l.8.8 6.3 6.5c13.6 13.4 29.5 27 48.5 27h7c23.4 0 43-17.5 61.2-32.3a66.5 66.5 0 1 1-2 101.8c-17-15-35.8-32-58.4-32H303c-20.2 0-37 15-51.2 29.5-14 14.1-28.4 30.7-28.4 50.6v4.5c0 17.5 10.2 32.8 21.6 46.8l.9 1 3.6 4.3.9 1 .9 1.1.9 1 .4.6.9 1 1.3 1.5a66.5 66.5 0 1 1-100.4-.2c14.8-17 31.5-35.7 31.5-58.1 0-22.5-16.7-41.2-31.5-58.2a66.3 66.3 0 0 1-1.2-85.9c15-18.2 32.7-37.8 32.7-61.4S168 163 153 144.8A66.5 66.5 0 0 1 204.4 36Z" />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default Logo;
